import {
    RevealButton,
    useRevealedNumber,
} from '../../../components/KYC/reveal';
import { Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import moment from 'moment';
import {
    CheckMarkGreen,
    CrossMarkIcon,
    ExclaimIcon,
} from '../../../assets/svg';
export const verifyKYCStyles = makeStyles((theme: any) => ({
    gridItemContainer: {
        display: 'flex',
        // justifyContent: 'space-around',
        alignItems: 'center',
        flexDirection: 'column',
        maxWidth: 'calc(50% - 12px)',
        marginRight: '12px',
        marginBottom: '12px',
        borderRadius: '16px',
        border: 'solid 1px rgba(38, 50, 56, 0.16)',
        backgroundColor: '#fff',
        padding: '12px 12px',
    },
    gridItemContainerWithErrorBorder: {
        display: 'flex',
        // justifyContent: 'space-around',
        alignItems: 'center',
        flexDirection: 'column',
        maxWidth: 'calc(50% - 12px)',
        marginRight: '12px',
        marginBottom: '12px',
        borderRadius: '16px',
        border: 'solid 2px #f44336',
        backgroundColor: '#fff',
        padding: '12px 12px',
    },
    title: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#14112d',
    },
    successIconStyle: {
        width: 20,
        color: 'green',
        marginLeft: 4,
    },
    errorIconStyle: {
        width: 20,
        color: 'red',
        marginLeft: 4,
    },
}));
const dobFormatString = 'DD/MM/YYYY';

export const formatDob = (value?: string | number) =>
    value ? moment(value).format(dobFormatString) : '';

export const RejectReasonRow: React.FC<{ reason?: string | null }> = ({
    reason,
}) => {
    if (!reason) return null;
    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                marginBottom: 8,
            }}
        >
            <Typography
                style={{ color: '#808080', fontSize: 14, fontWeight: 500 }}
            >
                Reject Reason:
            </Typography>
            <Typography
                style={{
                    color: '#f44336',
                    fontSize: 14,
                    fontWeight: 700,
                    marginLeft: 4,
                }}
            >
                {reason}
            </Typography>
        </Box>
    );
};

export const FieldRow: React.FC<{
    label: string;
    scannedValue?: string | number;
    enteredValue?: string | number;
    showEdited?: boolean;
    showWarning?: boolean;
    /** Reveal wiring. Omit and the row behaves exactly as before. */
    documentId?: number | string | null;
    documentType?: string | null;
    revealable?: boolean | null;
    imageRevealable?: boolean | null;
    imageUnmasked?: boolean | null;
    revealSubject?: string;
}> = ({
    label,
    scannedValue,
    enteredValue,
    showEdited,
    showWarning,
    documentId,
    documentType,
    revealable,
    revealSubject,
}) => {
    const revealed = useRevealedNumber(documentId);
    const mainValue = revealed ?? scannedValue ?? enteredValue ?? '';
    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                marginBottom: 8,
            }}
        >
            <Typography
                style={{ color: '#808080', fontSize: 14, fontWeight: 500 }}
            >
                {label}
            </Typography>

            <Typography
                style={{
                    color: showWarning ? '#f44336' : '#263238',
                    fontSize: 14,
                    fontWeight: 700,
                    marginLeft: 4,
                }}
            >
                {mainValue}
            </Typography>

            {showWarning && (
                <ExclaimIcon style={{ width: 16, height: 16, marginLeft: 4 }} />
            )}

            <Box style={{ marginLeft: 8 }}>
                <RevealButton
                    documentId={documentId}
                    documentType={documentType}
                    revealable={revealable}
                    action="UNMASK_NUMBER"
                    subject={revealSubject || 'document number'}
                />
            </Box>

            {showEdited && scannedValue && enteredValue && (
                <Box
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginLeft: 12,
                    }}
                >
                    <Typography
                        style={{
                            color: '#808080',
                            fontSize: 14,
                            fontWeight: 500,
                        }}
                    >
                        Edited:
                    </Typography>
                    <Typography
                        style={{
                            color: '#263238',
                            fontSize: 14,
                            fontWeight: 700,
                            marginLeft: 4,
                        }}
                    >
                        {enteredValue}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};
